import type { BoxProps } from "@mui/material/Box";
import type { useForm } from "hooks";
import type { BootstrapableForm, Option } from "types";
import { BusinessActivityOption } from "./BusinessActivityOption";

export type WithProductsAndServices<T extends Option> = T & {
    readonly productsAndServices: Array<Option>;
};

export const enum FormField {
    BusinessActivity = 'businessActivity',
    ProductService = 'productService',
    ProductServiceOther = 'productServiceOther',
    Email = 'email',
    Password = 'password',
    ConfirmPassword = 'confirmPassword'
}

export type PreApplication = {
    readonly [FormField.BusinessActivity]: BusinessActivityOption | null;
    readonly [FormField.ProductService]: Option | null;
    readonly [FormField.ProductServiceOther]: string;
    readonly [FormField.Email]: string;
    readonly [FormField.Password]: string;
    readonly [FormField.ConfirmPassword]: string;
};

export type PreApplicationBootstrapData = {
    readonly businessActivities: Array<WithProductsAndServices<Option>>;
};

export type PreApplicationForm = Omit<
    BootstrapableForm<PreApplication, PreApplicationBootstrapData>,
    | 'initialValues'
> & {
    readonly initialValues: PreApplication;
};

export type PreApplicationProps =
    & Pick<BoxProps, 'sx'>
    & PreApplicationForm
    & ReturnType<typeof useForm<PreApplication>>;
